const shader = `
varying vec3 vWorldDirection;

void main() {
    mat3 mtrx = mat3(
        vec3(1.0, 0.0, 0.0),
        vec3(0.0, 0.0, -1.0),
        vec3(0.0, 1.0, 0.0)
    );

    vWorldDirection = normalize(mtrx * position);
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`;

export default shader;